export const CONTROLS_ROW_CLASS_NAME = "m-1.25 mb-0 px-1 py-[3px]";

// 24px icon footprint in the row, 30px hover pill bleeding into the row padding
export const CONTROLS_ROW_BUTTON_CLASS_NAME =
  "-m-[3px] p-[3px] h-[30px] min-h-0 w-auto max-w-none rounded-6";
export const CONTROLS_ROW_BUTTON_WRAPPER_CLASS_NAME = "p-0";
export const CONTROLS_ROW_LABEL_CLASS_NAME =
  "pr-2 font-geist font-medium text-[16px] tracking-tight text-document-text";
